import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';
import get from 'lodash/get';

const CarouselItemDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  line-height: 24px;

  .surveyValue {
    min-width: 54px;
    height: 54px;
    background-color: rgba(43, 61, 84, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
    border-radius: 8px;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .surveyContent {
    margin-left: 15px;
  }

  .surveyText {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
  }

  .surveyDate {
    white-space: nowrap;
    color: #2b3d54;
    opacity: 0.5;
  }
`;

const CarouselItem = (wine: {
  wine_name: string;
  network_code: string;
  position?: number;
  displayed_currency?: string;
  avg_price?: number;
  avg_price_recent_vintage?: number;
}) => {
  const value = Number(
    // based on avg_price_post_90 as per API and JSON translation file
    get(wine, 'avg_price_recent_vintage')
      ? get(wine, 'avg_price_recent_vintage', 0)
      : get(wine, 'avg_price', 0)
  ).toLocaleString('fr-FR', {
    style: 'currency',
    currency: wine.displayed_currency ? wine.displayed_currency : 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });

  const title = `${wine.wine_name} - ${wine.network_code}`;

  const type = get(wine, 'avg_price_recent_vintage')
    ? I18n.t('prices.subTitleKpi')
    : I18n.t('averagePrice');

  return (
    <CarouselItemDiv>
      <div className="surveyValue">{value}</div>
      <div className="surveyContent">
        <div className="surveyText">
          <p>{title}</p>
        </div>
        <div className="surveyDate">
          <p>{type}</p>
        </div>
      </div>
    </CarouselItemDiv>
  );
};

export default CarouselItem;
